import { httpPublic } from "../http.service";

export const getPublicSurveyQuestions = (surveyId) => {
  return httpPublic.get(`/survey/${surveyId}`);
};

export const answerPublicSurvey = (surveyId, data) => {
  return httpPublic.patch(`/survey/${surveyId}`, data);
};

export const requestPasswordReset = (mail) => {
  return httpPublic.post("/password/forgot", { mail });
};

export const confirmPasswordReset = ({ token, newPassword }) => {
  return httpPublic.post("/password/reset", { token, newPassword });
};

export const resetAdminPasswort = (adminMail) => {
  return httpPublic.post(`/resetpassword/${adminMail}`);
};

export const activateUser = (token, data) => {
  return httpPublic.post(`/activate/${token}`, data);
};

export const getPublicSiteRegistration = (siteId) => {
  return httpPublic.get(`/site/${siteId}`);
};

export const createPublicRegistration = (siteId, data) => {
  return httpPublic.post(`/registration/${siteId}`, data);
};

export const validatePublicDiscountCode = (siteId, code) => {
  return httpPublic.get(`/registration/${siteId}/discount`, {
    params: { code },
  });
};

export const getPublicEventInfo = (eventId) => {
  return httpPublic.get(`/events/${eventId}`);
};

export const bookPublicEvent = (eventId, data) => {
  return httpPublic.post(`/events/${eventId}/book`, data);
};

export const getPublicEventRegistration = (eventId, token) => {
  return httpPublic.get(`/events/${eventId}/registration/${token}`);
};

export const updatePublicEventRegistration = (eventId, token, data) => {
  return httpPublic.patch(`/events/${eventId}/registration/${token}`, data);
};
